export const Types = {
    QUESTION_ANSWER_LIST: "QUESTION_ANSWER_LIST",
    SURVEY_QUES_ANS_LIST_ERROR:"SURVEY_QUES_ANS_LIST_ERROR",
    FLARE_TASK: "FLARE_TASK",
    IMMUNE_RAPID_SCORE: "IMMUNE_RAPID_SCORE"
  };
